import { Alert } from "@components";
import { bool, func, string } from "prop-types";
import { useTranslation } from "react-i18next";

export const ProjectAccessDeniedDialog = ({
  open,
  onClose,
  projectName,
  ownerEmail,
}) => {
  const { t } = useTranslation();

  return (
    <Alert
      isOpen={open}
      title={t("dialogs.projectAccessDenied.title", {defaultValue: "Project access denied"})}
      onAccept={onClose}
      acceptText={t("common.close")}
    >
      <p>
        {t("dialogs.projectAccessDenied.message", {
          defaultValue: projectName
            ? `You do not have access to project \"${projectName}\".`
            : "You do not have access to this project.",
        })}
      </p>
      {!!ownerEmail && (
        <p className="mt-4">
          {t("dialogs.projectAccessDenied.contactOwner", {
            defaultValue: `If needed, contact the project owner: ${ownerEmail}`,
          })}
        </p>
      )}
    </Alert>
  );
};

ProjectAccessDeniedDialog.propTypes = {
  open: bool,
  onClose: func.isRequired,
  projectName: string,
  ownerEmail: string,
};

